import React from 'react';
import { process } from '../mock/mock';
import BracketButton from './BracketButton';

const ProcessSection = () => {
  return (
    <section className="relative bg-neutral-950 text-white py-28 lg:py-36 overflow-hidden">
      <div className="absolute inset-0 grid-backdrop--dark opacity-30 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-[1.5px] bg-white/60" />
              <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/70">
                Getting Started
              </span>
            </div>
            <h2 className="big-display text-[54px] sm:text-[72px] lg:text-[96px] leading-[0.9]">
              Booking A Load
              <br />
              <span className="text-white/40">Is Simple.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="font-body text-white/75 text-base lg:text-[17px] leading-relaxed">
              Three steps. One dispatcher. Zero surprises. From the first call to the final signature, every mile is coordinated by people who know freight.
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/15 mb-16">
          {process.map((p) => (
            <div key={p.number} className="bg-neutral-950 p-8 lg:p-10 relative group">
              <div className="font-mono-tech text-[10px] tracking-[0.3em] text-white/50 mb-8">
                Step / {p.number}
              </div>
              <div className="big-display text-[80px] lg:text-[110px] leading-none text-white/10 absolute top-6 right-6 select-none group-hover:text-white/25 transition-colors">
                {p.number}
              </div>
              <h3 className="big-display text-[30px] lg:text-[36px] leading-tight mb-4 relative">
                {p.title}
              </h3>
              <p className="font-body text-white/70 text-sm lg:text-[15px] leading-relaxed relative">
                {p.body}
              </p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <BracketButton to="/process" variant="light">Learn More</BracketButton>
          <BracketButton to="/contact" variant="light">Request Quote</BracketButton>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
